import React from 'react';

import css from './TextMapper.module.scss';

const InviteParentText = () => (
  <div className={css.inviteParent}>
    <img src="../../static/greenlight-card-black.png" alt="Greenlight Card" />
    <p>Enter your name as it should appear on your Greenlight debit card.</p>
  </div>
);

export default InviteParentText;
